import { render, staticRenderFns } from "./InstallmentTable.vue?vue&type=template&id=3187b946&"
import script from "./InstallmentTable.vue?vue&type=script&lang=js&"
export * from "./InstallmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports